<template>
    <v-dialog max-width="500px" v-model="inDialog" env_index persistent>
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <i-upload 
                                :label="$t('lang.teacher.avatar')"
                                v-model="item.avatarId"
                                :value="item.avatarId"
                                file-type="sampleTrademark" 
                                :multifile="false"
                                name="avatarId"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete
                                :items="types"
                                :label="$t('lang.material.materialType')"
                                v-model="item.typeId"
                                name="typeId"
                                item-value="categoryId"
                                item-text="categoryName"
                                v-validate="'required'"
                                :data-vv-as="$t('lang.material.materialType')"
                                :error-messages="errors.first('typeId')"
                                v-on:change="typeChange(item.typeId)"
                            />
<!--                          :disabled="item.materialId ? true : false"-->
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Mã vật tư')"
                                v-model.trim="item.materialCode"
                                name="materialCode"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('materialCode')"
                                :data-vv-as="$t('Mã vật tư')"
                                disabled
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Tên vật tư')"
                                v-model.trim="item.materialName"
                                name="materialName"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('materialName')"
                                :data-vv-as="$t('Tên vật tư')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Đóng gói')"
                                v-model.trim="item.pack"
                                name="pack"
                                maxLength="250"
                                :error-messages="errors.first('pack')"
                                :data-vv-as="$t('Đóng gói')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Đơn vị tính')"
                                v-model.trim="item.unit"
                                name="unit"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('unit')"
                                :data-vv-as="$t('Đơn vị tính')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('NSX/Xuất xứ')"
                                v-model.trim="item.manufacturer"
                                name="manufacturer"
                                maxLength="250"
                                :error-messages="errors.first('manufacturer')"
                                :data-vv-as="$t('NSX/Xuất xứ')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete
                                :items="supplys"
                                :label="$t('Nhà cung cấp')"
                                v-model="item.supplyId"
                                name="supplyId"
                                item-value="partnerId"
                                item-text="partnerName"
                                :data-vv-as="$t('Nhà cung cấp')"
                                :error-messages="errors.first('supplyId')"
                                multiple
                                clearable
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Ghi chú')"
                                v-model.trim="item.note"
                                name="note"
                                maxLength="250"
                                :error-messages="errors.first('note')"
                                :data-vv-as="$t('Ghi chú')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="materialStatus"
                                :label="$t('Trạng thái')"
                                v-model="item.status"
                                name="status"
                                item-value="value"
                                item-text="text"
                                v-validate="'required'"
                                :data-vv-as="$t('Trạng thái')"
                                :error-messages="errors.first('status')"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import { cateContants } from "@/constants";
import IUpload from "@/components/form/Upload";

export default {
    name: "partner-create",
    components: { message, axios, IUpload },
    props: {
        propsItem: {
            type: Object,
            default: () => {
                    return {}
                }
        },
        formCreateName: {
            type: String,
            default: '',
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        units: {
            type: Array,
            default: [],
        },
        types: {
            type: Array,
            default: [],
        },
        countrys: {
            type: Array,
            default: [],
        },
        supplys: {
            type: Array,
            default: [],
        },
        packs: {
            type: Array,
            default: [],
        },
        hiddenFields: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data: () => {
        return {
            formName: "Cập nhật vật tư",
            inDialog: false,
            materialStatus: cateContants.materialStatus,
            item: {
                countryId: 0,
                manufacturer: "",
                materialName: "",
                note: "",
                pack: "",
                status: 1,
                supplyId: 0,
                typeId: '',
                unit: "",
                avatarId: '',
            },
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                console.log(value);
                if (value !== null) {
                    if (value.supplyId != null && typeof value.supplyId == 'string' && value.supplyId.length > 0) {
                        const items = [];
                        const uArr = value.supplyId.split(",");
                        uArr.forEach((v) => {
                            items.push(parseInt(v));
                        });
                        value.supplyId = items;
                    }

                    this.item = {
                        materialId: value.materialId,
                        countryId: value.countryId ? value.countryId : 0,
                        manufacturer: value.manufacturer
                            ? value.manufacturer
                            : "",
                        materialName: value.materialName
                            ? value.materialName
                            : "",
                        materialCode: value.materialCode
                            ? value.materialCode
                            : "",
                        note: value.note ? value.note : "",
                        pack: value.pack ? value.pack : "",
                        status: value.status ? value.status : 0,
                        supplyId: value.supplyId ? value.supplyId : '',
                        typeId: value.typeId ? value.typeId : '',
                        productType: value.productType?value.productType:null,
                        unit: value.unit ? value.unit : "",
                        avatarId: value.avatarId ? value.avatarId : "",
                    };
                    // console.log(this.item);
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            } else {
                if ((this.item.materialId == undefined || this.item.materialId == '' || this.item.materialId == null) && this.item.typeId != '' && parseInt(this.item.typeId) > 0) {
                    this.getNextCode();
                } 
            }
        },
        hiddenFields(value) {
            this.item.typeId = value.typeId ? value.typeId : '';
            this.item.productType=value.productType?value.productType:null;
        },
    },
    methods: {
        resetFrom: function () {
            this.item = {
                countryId: 0,
                manufacturer: "",
                materialName: "",
                note: "",
                pack: "",
                status: 1,
                supplyId: 0,
                typeId: this.hiddenFields.typeId ? this.hiddenFields.typeId : '',
                productType: this.hiddenFields.productType ? this.hiddenFields.productType : null,
                unit: "",
                avatarId: '',
            };
        },
        onCancel: function () {
            this.$emit("closeCreateDialog", "");
        },
        onSave: function () {
            // console.log(this.item);
            this.$validator.validate().then((valid) => {

                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }

                const item_tmp = this.item;

                if (item_tmp.supplyId && item_tmp.supplyId.length > 0 && typeof item_tmp.supplyId == 'object') {
                    item_tmp.supplyId = item_tmp.supplyId.join();
                } else{
                  item_tmp.supplyId = undefined;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/material/save",
                        item_tmp
                    )
                    .then(
                        (data) => {
                            console.log(data);
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        typeChange(typeId) {
            this.getNextCode();
        },
        getNextCode: function () {
            let areaCode = "";
            for(let i=0; i < this.types.length; i++){
                if(this.types[i].categoryId == this.item.typeId){
                    if (this.types[i].parentName != null && this.types[i].parentName != '') {
                        areaCode = this.types[i].parentName;
                    } else {
                        let typeName = this.types[i].categoryName;
                        areaCode = typeName.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a").replace(/\ /g, '').replace(/đ/g, "d").replace(/đ/g, "d").replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y").replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u").replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ.+/g,"o").replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ.+/g, "e").replace(/ì|í|ị|ỉ|ĩ/g,"i");
                        areaCode = areaCode.toUpperCase();
                    }
                    break;
                }
            }

            if(areaCode != ""){
                axios.get(
                    process.env.VUE_APP_API_URL +
                    "/autoIncrease/getNextCode?type=MATERIAL_" + areaCode + "&prefix="+areaCode+"&numberZeroBeforeCodeNumberCode=1&suffix="
                ).then((data) => {
                        this.item = Object.assign({}, this.item, {"materialCode": data})
                    });
            }
        },
    },
    created() {},
};
</script>
